import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrownGradient = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 10,
	viewBox: "0 0 14 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5757 9.02344H2.55987C2.424 9.02363 2.29181 8.97736 2.18284 8.89149C2.07387 8.80554 1.994 8.68456 1.95515 8.54661L0.0327562 2.73141C-0.00803301 2.60261 -0.0107955 2.46361 0.0248467 2.3331C0.0604889 2.20258 0.132835 2.08667 0.232221 2.0009C0.331617 1.91513 0.453327 1.86352 0.581112 1.85302C0.708887 1.84244 0.836655 1.87354 0.947343 1.94204L3.59288 4.03901L6.08216 0.24576C6.10412 0.213322 6.13039 0.184511 6.16027 0.160278C6.27364 0.0574332 6.41789 0.000572422 6.56717 0H6.61504C6.69746 0.00686906 6.77791 0.031006 6.85161 0.0708847C6.9253 0.110763 6.9909 0.165621 7.04462 0.232403L9.54398 4.02565L12.2134 1.94204C12.3221 1.88775 12.4432 1.86753 12.5625 1.88384C12.6816 1.90025 12.794 1.95234 12.8861 2.0342C12.9822 2.11491 13.0541 2.22357 13.0928 2.34693C13.1315 2.47038 13.1354 2.60299 13.1041 2.72874L11.1792 8.54795C11.1401 8.68542 11.0604 8.80592 10.9517 8.89159C10.843 8.97726 10.7112 9.02344 10.5757 9.02344Z",
			fill: "url(#paint0_linear_19016_10321)"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_19016_10321",
			x1: 11.7534,
			y1: -8.87306,
			x2: -2.15453,
			y2: -5.99659,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#2214E4" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .52,
					stopColor: "#D696CE"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#2F67FE"
				})
			]
		}) })
	]
});
const ForwardRef = forwardRef(SvgCrownGradient);
export default ForwardRef;
